import Client from '../HttpClient';

const numbatUrl = '/gateway/numbat-api/api/vs/payment-method';
const list = () => {
	return Client.get('/admin/api/payment-method');
};

const listCloud = (merchantId, branchId) => {
	return Client.get(`${numbatUrl}/${merchantId}/${branchId}`);
};

const create = (data) => {
	return Client.post(`/admin/api/payment-method`, data);
};
const createCloud = (merchantId, branchId, data) => {
	return Client.post(`${numbatUrl}/${merchantId}/${branchId}`, data);
};
const find = (Code) => {
	return Client.get(`/admin/api/payment-method/${Code}`);
};

const update = (code, data) => {
	return Client.put(`/admin/api/payment-method/${code}`, data);
};
const updateCloud = (merchantId, branchId, code, data) => {
	return Client.put(`${numbatUrl}/${merchantId}/${branchId}/${code}`, data);
};
const remove = (Code) => {
	return Client.del(`/admin/api/payment-method/${Code}`);
};
const removeCloud = (merchantId, branchId, Code) => {
	return Client.del(`${numbatUrl}/${merchantId}/${branchId}/${Code}`);
};

const sequence = (Sequence) => {
	return Client.put(`/admin/api/payment-method/arrange`, Sequence);
};
const sequenceCloud = (merchantId, branchId, Sequence) => {
	return Client.put(`${numbatUrl}/${merchantId}/${branchId}/arrange`, Sequence);
};

export default {
	list,
	find,
	create,
	update,
	remove,
	sequence,
	listCloud,
	createCloud,
	updateCloud,
	removeCloud,
	sequenceCloud,
};
